import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import PrintEstimateDoc from "../config/core/printestimatedoc";

export default function PrintEstimate() {
    let location = useLocation();
    const model = location.state.model;

    useEffect(() => {
        if (!location.state?.model) {
            window.history.back();
        }
    }, []);
    return (
        <>
            <PrintEstimateDoc model={model} />
        </>
    );
}
